export type LayoutBox = { x: number; y: number; w: number; h: number };
export type LayoutColumn = { x: number; w: number };

export type GameLayoutProfile = 'landscape' | 'portrait';
export type SpecialSpinKind = 'none' | 'flags' | 'crosses';

export type GameLayout = {
  profile: GameLayoutProfile;
  refW: number;
  refH: number;
  minScale: number;
  reelX: number[];
  reelY: number;
  reelW: number;
  reelH: number;
  drawLeft: LayoutBox;
  drawRight: LayoutBox;
  topRoundBox: LayoutBox;
  topTimerBar: LayoutBox;
  topScoreBox: LayoutBox;
  rightCellLeft: LayoutColumn;
  rightCellRight: LayoutColumn;
  comboY: number[];
  comboH: number[];
  comboPanelPadX: number;
  leftAreaAnchorX: number;
};

export const GAME_LAYOUTS: Record<GameLayoutProfile, GameLayout> = {
  landscape: {
    profile: 'landscape',
    refW: 1210, refH: 550, minScale: 0.52,
    reelX: [76, 228, 380, 532, 684], reelY: 260, reelW: 152, reelH: 376,
    drawLeft:     { x: 232, y: 494, w: 236, h: 56 },
    drawRight:    { x: 560, y: 494, w: 236, h: 56 },
    topRoundBox:  { x: 42,  y: 28,  w: 78,  h: 30 },
    topTimerBar:  { x: 448, y: 28,  w: 734, h: 16 },
    topScoreBox:  { x: 806, y: 28,  w: 78,  h: 30 },
    rightCellLeft:  { x: 890,  w: 180 },
    rightCellRight: { x: 1090, w: 180 },
    // comboY starts at 140 so the first row clears the header (~98 ref-units tall)
    comboY: [140, 214, 288, 362, 436, 510],
    comboH: [70, 70, 70, 70, 70, 70],
    comboPanelPadX: 8,
    leftAreaAnchorX: 380,
  },
  portrait: {
    profile: 'portrait',
    refW: 640, refH: 1380, minScale: 0.44,
    reelX: [63, 184, 305, 426, 547], reelY: 328, reelW: 110, reelH: 410,
    drawLeft:     { x: 160, y: 604, w: 226, h: 70 },
    drawRight:    { x: 480, y: 604, w: 226, h: 70 },
    topRoundBox:  { x: 102, y: 36, w: 106, h: 36 },
    topTimerBar:  { x: 320, y: 36, w: 290, h: 16 },
    topScoreBox:  { x: 538, y: 36, w: 106, h: 36 },
    rightCellLeft:  { x: 170, w: 300 },
    rightCellRight: { x: 470, w: 300 },
    comboY: [694, 788, 882, 976, 1070, 1164],
    comboH: [86, 86, 86, 86, 86, 86],
    comboPanelPadX: 8,
    leftAreaAnchorX: 305,
  },
};

export function pickLayout(width: number, height: number): GameLayout {
  const profile: GameLayoutProfile = height >= width * 1.02 ? 'portrait' : 'landscape';
  return GAME_LAYOUTS[profile];
}
